import { STORAGE_KEYS } from './storageKeys'

/**
 * 서버측 refresh 키가 `(memberId, deviceId)` 라 브라우저마다 **안정적이기만** 하면 된다.
 *
 * device ID 하나 때문에 Firebase installations 를 도입하지 않는다(YAGNI).
 * 로그아웃 시에도 지우지 않아 같은 브라우저 재로그인에서 서버 refresh 행을 재사용한다.
 */
export function getDeviceId(): string {
  const existing = localStorage.getItem(STORAGE_KEYS.deviceId)
  if (existing) return existing

  const generated =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`

  localStorage.setItem(STORAGE_KEYS.deviceId, generated)
  return generated
}
